import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import timing from 'common/stylesheets/mixins/timing.json';

import template from './index.jade';
import css from './index.styl?inline';

const ARROW_ALIGN = {
  LEFT: `left`,
  RIGHT: `right`,
  TOP: `top`,
  BOTTOM: `bottom`,
  CENTER: `center`,
};

const PLACEMENT = {
  ...ARROW_ALIGN,
};

export class TutorialTooltip extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'arrow-align': {type: `string`, default: ARROW_ALIGN.TOP, enum: Object.values(ARROW_ALIGN)},
      closeable: `boolean`,
      'curr-step': `number`,
      hide: `boolean`,
      'hide-footer': `boolean`,
      'next-button': `boolean`,
      'num-steps': `number`,
      placement: {type: `string`, default: PLACEMENT.TOP, enum: Object.values(PLACEMENT)},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        numSteps: 0,
        currStep: 0,
        delayRemove: timing[`$mp-slow`],
      },
      helpers: {
        close: (ev) => {
          ev.stopPropagation();
          this.dispatchEvent(new CustomEvent(`close`));
        },
        next: (ev) => {
          ev.stopPropagation();
          this.dispatchEvent(new CustomEvent(`next`));
        },
        getSteps: () => [...Array(this.state.numSteps).keys()],
      },
    };
  }

  attributeChangedCallback() {
    super.attributeChangedCallback(...arguments);

    const update = {};
    const numSteps = this.attr(`num-steps`);
    const currStep = this.attr(`curr-step`);

    if (Number.isInteger(numSteps)) {
      update.numSteps = numSteps;
    }
    if (Number.isInteger(currStep)) {
      update.currStep = currStep;
    }

    this.update(update);
  }
}

export const TutorialTooltipEl = defineAndMakeJsxFactory(`mp-tutorial-tooltip`, TutorialTooltip);
